import { useEffect, useState } from "react"
import Grid from "@mui/material/Grid"
import Card from "@mui/material/Card"
import TextField from "@mui/material/TextField"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import DashboardLayout from "monitor/LayoutContainers/DashboardLayout"
import DashboardNavbar from "monitor/Navbars/DashboardNavbar"
import Footer from "monitor/Footer"
import DataTable from "monitor/Tables/DataTable"
import Icon from "@mui/material/Icon"
import { Link, useNavigate } from "react-router-dom"
import config from "config"
import MDButton from "components/MDButton"

import Swal from "sweetalert2"
import { showToast } from "utils/swalToast"
import {
  Chip,
  CircularProgress,
  FormControl,
  InputLabel,
  Menu,
  MenuItem,
  Select,
  Stack,
} from "@mui/material";
import ModalSelector from "components/ModalSelector";

function Usuarios() {
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))
  const [data, setData] = useState([])
  const navigate = useNavigate()
  const [usernameFilter, setUsernameFilter] = useState("")
  const [nombreFilter, setNombreFilter] = useState("")
  const [cedulaFilter, setCedulaFilter] = useState("")
  const [empresas, setEmpresas] = useState([])
  const [empresaFilter, setEmpresaFilter] = useState("")
  const [sucursales, setSucursales] = useState([])
  const [sucursalesFilter, setSucursalesFilter] = useState("")
  const [eventos, setEventos] = useState([])
  const [eventosFilter, setEventosFilter] = useState("")

  const [anchorEl, setAnchorEl] = useState(null);
  const [exportFormat, setExportFormat] = useState("XLSX");
  const [isDownloading, setIsDownloading] = useState(false);
  const [expandedSucursales, setExpandedSucursales] = useState({});

  const toggleSucursales = (idUsuario) => {
    setExpandedSucursales((prev) => ({
      ...prev,
      [idUsuario]: !prev[idUsuario],
    }));
  };

  const handleMenuOpen = (e) => {
    setAnchorEl(e.currentTarget)
  }

  const handleMenuClose = (format) => {
    setAnchorEl(null)
    if (format) {
      setExportFormat(format)
      handleDownload(format)
    }
  }

  const handleDownload = async (format = exportFormat) => {
    console.log("fetchData")
    setIsDownloading(true)
    const ext = format.toLowerCase()
    let apiUrl = `${config.api.baseURL}/usuarios/export/${format}?`

    if (empresaFilter) {
      apiUrl += `empresaFilter=${encodeURIComponent(empresaFilter)}&`
    }
    if (sucursalesFilter) {
      apiUrl += `sucursalesFilter=${encodeURIComponent(sucursalesFilter)}&`
    }
    if (eventosFilter) {
      apiUrl += `eventosFilter=${encodeURIComponent(eventosFilter)}&`
    }
    if (usernameFilter) {
      apiUrl += `usernameFilter=${encodeURIComponent(usernameFilter)}&`
    }
    if (nombreFilter) {
      apiUrl += `nombreFilter=${encodeURIComponent(nombreFilter)}&`
    }
    if (cedulaFilter) {
      apiUrl += `cedulaFilter=${encodeURIComponent(cedulaFilter)}&`
    }
    try {
      const res = await fetch(apiUrl, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      })
      if (!res.ok) throw new Error("Error al descargar el archivo.")
      const blob = await res.blob()
      const fileName = `export.${ext === "xlsx" ? "xlsx" : "pdf"}`
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = url
      link.setAttribute("download", fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (error) {
      console.error("Error al descargar el archivo:", error)
    } finally {
      setIsDownloading(false)
    }
  }

  const columns = [
    { Header: "Item", accessor: "item", width: "1%" },
    { Header: "Usuario", accessor: "username", width: "10%" },
    { Header: "Nombre y apellido", accessor: "personas.nombre", width: "15%" },
    {
      Header: "Sucursales",
      accessor: "sucursales",
      width: "20%",
      Cell: ({ value, row }) => {
        const items = Array.isArray(value) ? value : [];
        const idUsuario = row?.original?.idUsuario ?? row?.index; // fallback
        const isExpanded = Boolean(expandedSucursales[idUsuario]);

        const visibleItems = isExpanded ? items : items.slice(0, 1);
        const showToggle = items.length > 1;

        return (
          <MDBox>
            <MDBox display="flex" flexWrap="wrap" gap={0.5}>
              <Stack>{visibleItems.map((s, i) => (
                <Chip
                  key={`${idUsuario}-sucu-${i}`}
                  label={`${s.descripcion} (${s.empresa?.descripcion})`}
                  variant="outlined"
                  size="small"
                  color="primary"
                  sx={{ mr: 0.5, mb: 0.5 }}
                />
              ))}</Stack>
            </MDBox>

            {showToggle && (
              <MDButton
                variant="outlined"
                color="warning"
                size="small"
                sx={{ mt: 0.5, p: 1, minWidth: "auto", fontSize:"9px", fontWeight:"light" }}
                onClick={() => toggleSucursales(idUsuario)}
              >
                {isExpanded ? "Ver menos" : "Ver más"}
              </MDButton>
            )}
          </MDBox>
        );
      },
    },
    {
      Header: "Eventos",
      accessor: "eventos",
      width: "20%",
      Cell: ({ value }) =>
        Array.isArray(value)
          ? value.map((s, i) => (
            <>
              <Chip
                key={i}
                label={`${s.descripcion} (${s.empresa?.descripcion})`}
                variant="outlined"
                size="small"
                color="primary"
                sx={{ mr: 0.5, mb: 0.5 }}
              />
              <br />
            </>
          ))
          : null,
    },
    {
      Header: "Activo",
      accessor: "activo",
      width: "5%",
      // eslint-disable-next-line react/prop-types
      Cell: ({ value }) => (
        <Chip
          label={value ? "Si" : "No"}
          variant="outlined"
          size="small"
          color={value ? "success" : "danger"}
          sx={{ mr: 0.5, mb: 0.5 }}
        />
      ),
    },
    { Header: "Acciones", accessor: "action", align: "center", width: "5%" },
  ]

  const handleUsernameFilterSearch = (event) => {
    const term = event.target.value
    setUsernameFilter(term)
  }

  const getEmpresas = async () => {
    try {
      let empUrl = `${config.api.baseURL}/empresas`
      const response = await fetch(empUrl, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      if (response.status === 200) {
        const result = await response.json()
        if (result) {
          setEmpresas(result)
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

  const handleEmpresasChange = (e) => {
    const selectedId = e.target.value
    setEmpresaFilter(selectedId)
    fetchSucursales(selectedId)
    fetchEventos(selectedId)
  }

  const handleEventosChange = (selectedId) => {
    setEventosFilter(selectedId);
  };

  const handleSucursalesChange = (selectedId) => {
    setSucursalesFilter(selectedId);
  };

  const fetchSucursales = async (selectedId) => {
    try {
      if (selectedId) {
        let sucuUrl = `${config.api.baseURL}/sucursales/empresa/${selectedId}`
        const response = await fetch(sucuUrl, {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        })

        if (response.status === 200) {
          const result = await response.json()
          setSucursalesFilter("")
          if (result) {
            setSucursales(result)
          }
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

  const fetchEventos = async (selectedId) => {
    try {
      if (selectedId) {
        let eveUrl = `${config.api.baseURL}/eventos/empresa/${selectedId}`
        const response = await fetch(eveUrl, {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        })

        if (response.status === 200) {
          const result = await response.json()
          setEventosFilter("")
          if (result) {
            setEventos(result)
          }
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

  const handleNombreFilterSearch = (event) => {
    const term = event.target.value
    setNombreFilter(term)
  }

  const handleCedulaFilterSearch = (event) => {
    const term = event.target.value
    setCedulaFilter(term)
  }

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault()
      fetchUsuarios(usernameFilter, nombreFilter, cedulaFilter, setData)
    }
  }

  const fetchUsuarios = async (usernameFilter, nombreFilter, cedulaFilter, setData) => {
    try {
      const queryParams = new URLSearchParams()

      if (usernameFilter) queryParams.append("usernameFilter", usernameFilter)
      if (nombreFilter) queryParams.append("nombreFilter", nombreFilter)
      if (cedulaFilter) queryParams.append("cedulaFilter", cedulaFilter)
      if (empresaFilter) queryParams.append("empresaFilter", empresaFilter)
      if (sucursalesFilter) queryParams.append("sucursalesFilter", sucursalesFilter)
      if (eventosFilter) queryParams.append("eventosFilter", eventosFilter)

      const queryString = queryParams.toString()

      let url = queryString
        ? `${config.api.baseURL}/usuarios/filtrar?${queryString}`
        : `${config.api.baseURL}/usuarios/filtrar`

      const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      if (response.status === 200) {
        const result = await response.json()
        addColumns(result)
        setData(result)
      }
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

  function addColumns(dataColumns) {
    let c = 0
    dataColumns.map((d) => {
      const { id } = d
      d.action = (
        <MDBox>
          {d.idUsuario !== 1 && (
            <>
              <MDButton
                sx={{ mr: 1 }}
                variant="gradient"
                color="success"
                iconOnly
                onClick={() => handleEdit(d.idUsuario)}
              >
                <Icon>edit</Icon>
              </MDButton>
              <MDButton
                variant="gradient"
                color="error"
                iconOnly
                onClick={() => handleDelete(d.idUsuario)}
              >
                <Icon>delete</Icon>
              </MDButton>
            </>
          )}
        </MDBox>
      )
      d.activo ? (d.activo = "Si") : (d.activo = "No")
      d.item = ++c
    })
    return dataColumns
  }

  function handleDelete(id) {
    console.log(id)
    //En caso de que se salto el boton desabilitado se valida una vez mas que no sea el admin
    if (id === 1) {
      showToast({ icon: "error", title: "Error", text: "No se pudo eliminar el usuario." })
      return
    }
    Swal.fire({
      title: "¿Está seguro que desea eliminar este usuario?",
      text: "¡No podrás revertir esta acción!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        // El usuario confirmó la eliminación, realizar la solicitud DELETE
        let url = `${config.api.baseURL}/usuarios/${id}`
        const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

        fetch(url, {
          method: "DELETE",
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        })
          .then((response) => {
            if (response.status === 200) {
              showToast({ title: "Usuario eliminado exitosamente", icon: "success" })
              fetchUsuarios(usernameFilter, nombreFilter, cedulaFilter, setData)
            } else {
              showToast({
                icon: "error",
                title: "Error",
                text: response.body.error || "No se pudo eliminar el usuario.",
              })
            }
          })
          .catch((error) => {
            const err = error.message
            showToast({ icon: "error", title: "Error", text: err })
          })
      }
    })
  }

  function handleEdit(id) {
    navigate(`/usuarios/${id}`)
  }

  useEffect(() => {
    getEmpresas()
    fetchUsuarios(usernameFilter, nombreFilter, cedulaFilter, setData)
  }, [])

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3}>
        <Grid container spacing={5} justifyContent="space-between">
          <Grid item xs={12}>
            <Card sx={{ p: 2, mb: 3 }}>
              <MDTypography variant="h6" color="text" gutterBottom>
                Filtros
              </MDTypography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth>
                    <InputLabel>Empresa</InputLabel>
                    <Select
                      label="Empresa"
                      variant="outlined"
                      fullWidth
                      value={empresaFilter}
                      onChange={handleEmpresasChange}
                      sx={{ p: 1.5 }}
                      placeholder="Seleccione.."
                    >
                      <MenuItem value="">Ninguna</MenuItem>
                      {empresas.map((emp) => (
                        <MenuItem key={emp.idEmpresa} value={emp.idEmpresa}>
                          {emp.descripcion}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <ModalSelector
                    value={sucursalesFilter}
                    onChange={handleSucursalesChange}
                    items={sucursales}
                    itemValue="idSucursal"
                    itemLabel="descripcion"
                    label="Sucursal"
                    placeholder="Seleccione una sucursal"
                    searchPlaceholder="Buscar sucursal..."
                    emptyText="No se encontraron sucursales"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <ModalSelector
                    value={eventosFilter}
                    onChange={handleEventosChange}
                    items={eventos}
                    itemValue="idEvento"
                    itemLabel="descripcion"
                    label="Evento"
                    placeholder="Seleccione un evento"
                    searchPlaceholder="Buscar evento..."
                    emptyText="No se encontraron eventos"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    label="Usuario"
                    variant="outlined"
                    fullWidth
                    value={usernameFilter}
                    onChange={handleUsernameFilterSearch}
                    onKeyDown={handleKeyDown}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    label="Nombre"
                    variant="outlined"
                    fullWidth
                    value={nombreFilter}
                    onChange={handleNombreFilterSearch}
                    onKeyDown={handleKeyDown}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    label="Cédula"
                    variant="outlined"
                    fullWidth
                    value={cedulaFilter}
                    onChange={handleCedulaFilterSearch}
                    onKeyDown={handleKeyDown}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <MDBox display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                    <MDBox>
                      <MDButton
                        type="button"
                        variant="gradient"
                        color="info"
                        onClick={() =>
                          fetchUsuarios(usernameFilter, nombreFilter, cedulaFilter, setData)
                        }
                      >
                        Buscar
                      </MDButton>
                      &nbsp;
                      <MDButton
                        type="button"
                        variant="outlined"
                        color="info"
                        onClick={() => {
                          setUsernameFilter("")
                          setNombreFilter("")
                          setCedulaFilter("")
                          setEmpresaFilter(null)
                          setSucursalesFilter(null)
                          setEventosFilter(null)
                          fetchUsuarios("", "", "", setData)
                        }}
                      >
                        Limpiar
                      </MDButton>
                      &nbsp;
                      <MDButton
                        color="success"
                        variant="outlined"
                        onClick={handleMenuOpen}
                        endIcon={
                          isDownloading ? (
                            <CircularProgress size={20} />
                          ) : (
                            <Icon>arrow_drop_down</Icon>
                          )
                        }
                        disabled={isDownloading}
                      >
                        {isDownloading ? "Generando..." : `Descargar`}
                      </MDButton>
                      <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={() => handleMenuClose()}
                      >
                        <MenuItem onClick={() => handleMenuClose("XLSX")}>Excel (XLSX)</MenuItem>
                        <MenuItem onClick={() => handleMenuClose("PDF")}>PDF</MenuItem>
                      </Menu>
                    </MDBox>
                    <Link to="/usuarios/agregar" style={{ textDecoration: "none" }}>
                      <MDButton type="button" variant="gradient" color="success">
                        Agregar
                      </MDButton>
                    </Link>
                  </MDBox>
                </Grid>
              </Grid>
            </Card>
            {/* </MDBox> */}
            <Card>
              <MDBox pt={3}>
                <DataTable
                  isSorted={false}
                  noEndBorder
                  showTotalEntries={false}
                  entriesPerPage={false}
                  canSearch={false}
                  table={{
                    columns: columns,
                    rows: data,
                  }}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  )
}

export default Usuarios
